import type { StatusTone } from "_shared/_views/tables/status-chip";
import {
  AWAITING_YOUR_APPROVAL,
  AWAITING_YOUR_REVIEW,
  HumanReadableProposalStatus,
} from "work/proposals/__constants/proposal-lifecycle";

// At rest, or over: nothing is moving and nobody is waited on.
const NEUTRAL: ReadonlySet<string> = new Set([
  HumanReadableProposalStatus.AwaitingSubmission,
  HumanReadableProposalStatus.RevisionRejected,
  HumanReadableProposalStatus.Canceled,
  HumanReadableProposalStatus.AwardedElsewhere,
  HumanReadableProposalStatus.Archived,
  HumanReadableProposalStatus.Unknown,
]);

/**
 * The tone of a proposal's status chip, from the status the row shows (`Proposal.displayStatus`)
 * (#6713). Hired is settled. Waiting on the reader (`AWAITING_YOUR_APPROVAL`, `AWAITING_YOUR_REVIEW`)
 * is a warning. A draft or a closed proposal is neutral. Every other status is with someone else, and
 * is moving.
 */
export function proposalStatusTone(displayStatus: string): StatusTone {
  if (displayStatus === AWAITING_YOUR_APPROVAL || displayStatus === AWAITING_YOUR_REVIEW) return "warning";
  if (displayStatus === HumanReadableProposalStatus.Hired) return "success";
  if (NEUTRAL.has(displayStatus)) return "neutral";
  return "info";
}
